import { render, staticRenderFns } from "./ActivityCreateFrom.vue?vue&type=template&id=10ccedca&"
import script from "./ActivityCreateFrom.vue?vue&type=script&lang=js&"
export * from "./ActivityCreateFrom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports